import { Badge, Chip } from '@mui/material';
import React, { FC } from 'react';

import { Link, useLocation } from 'react-router-dom';

import translate from '../../../../i18n/translate';
import { getOpenComposeSectionUrl } from '../../../../routes/urls/searchParams/compose';
import MuiIcon from '../../../MUI/MuiIcon';

import { ComposeFooterItem } from './types';

/**
 * Compose footer navigation item
 *
 * @param props           Props passed to the component
 * @param props.isChanged Should the item be marked as changed
 * @param props.label     The label to show for the item
 * @param props.mode      The mode of the item (compose section)
 *
 * @returns               The component itself
 */
const ComposeFooterNavItem: FC<ComposeFooterItem> = props => {
  const location = useLocation();
  const { isChanged = false, mode } = props;

  const openComposeSectionUrl = getOpenComposeSectionUrl(location, mode);
  const hasLabel = 'label' in props;

  return (
    <Badge
      color="error"
      component={Link}
      invisible={!isChanged}
      to={openComposeSectionUrl}
      variant="dot"
    >
      {hasLabel ? (
        <Chip label={translate(props.label)} />
      ) : (
        <MuiIcon color="primary" icon={props.icon} />
      )}
    </Badge>
  );
};

export default ComposeFooterNavItem;
